import { Component, OnInit, Input, HostListener, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { FormsErrorsService } from '../../services/forms-error.service';

@Component({
  selector: 'mapfre-auditlib-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ButtonComponent implements OnInit {

  @Input() routerLink: any;
  @Input() type: any;
  @Input() form: any;
  @Input() disabled: boolean = false;
  @Input() popup: boolean = false;
  constructor(private router: Router,private formsErrorService:FormsErrorsService) {

  }

  ngOnInit() {
  }

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent) {
    if (this.disabled) {
      event.stopPropagation();
      event.preventDefault();
      return;
    }
    console.log("click button", this.routerLink, this.form);
    this.navigate();
    this.markFormAsTouched();
  }

  markFormAsTouched() {
    if (this.form) {
      this.form.markAllAsTouched();
      this.formsErrorService.notifyVisible(true);
    }
  }

  navigate() {
    console.log('navigate', this.routerLink);
    if (this.routerLink) {
      this.router.navigate([this.routerLink]);
    }


  }

}
